<template>
    <div class="input-group">
        <input type="text" v-model="displayDate" class="form-control date-is-editable" autocomplete="off" disabled />
        <div class="input-group-append">
            <button type="button" class="btn btn-dark mb-0 input-group-btn" style="border-radius: 0;"
                    @click="entredDate = null">
                <fa-icon icon="fas fa-xmark"></fa-icon>
            </button>
            <button type="button" class="btn btn-info mb-0 input-group-btn"
                    @click="show_datepicker = true">
                <fa-icon icon="fas fa-calendar-alt"></fa-icon>
            </button>
        </div>
    </div>
    <persian-date-time
    v-model="entredDate"
    :auto-submit="true"
    :show="show_datepicker"
    format="jYYYY/jMM/jDD"
    display-format="jYYYY/jMM/jDD"
    custom-input=".custom-input-date"
    @close="closePanel"
    />
</template>

<script>
    import PersianDateTime from "vue3-persian-datetime-picker";

    export default {
        name: "CustomDatePicker",
        components: {
            PersianDateTime
        },
        props: {
            selectedDate: {
                type: String,
                default : ''
            }
        },
        data() {
            return {
                show_datepicker: false,
                entredDate : null,
                displayDate: null,
            };
        },
        computed: {
        },
        watch: {
            selectedDate(selectedDate){
                this.entredDate = this.$filters.toDateString(selectedDate);
            },
            entredDate(entredDate){
                this.displayDate = entredDate;
                this.$emit('update:selectedDate', entredDate);
            },
        },
        methods: {
            closePanel() {
                this.show_datepicker = false;
            }
        },
        created() {
        },
        mounted() {
        }
    };
</script>